module.exports = "<div class=\"layer-manager\">\r\n\t<ansyn-layer-tree [source$]=\"nodes$\" (nodeActivationChanged)=\"onNodeActivationChanged($event)\"></ansyn-layer-tree>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/layers-manager/components/layers-manager/layers-manager.component.html
// module id = ../../../../../src/app/packages/menu-items/layers-manager/components/layers-manager/layers-manager.component.html
// module chunks = main